<form #f="ngForm" style="width: 100%;">

  <div>
    @if (errorMessage) {
      <p-message [text]="errorMessage" severity="error" class="mt-3"></p-message>
    }
    <p-fileupload #theFileUpload name="files[]"
      [customUpload]="true" (uploadHandler)="doUpload($event)" (onProgress)="onProgress($event)"
      [multiple]="true" accept="application/pdf" [maxFileSize]="100000000" [showCancelButton]="false"
      [auto]="errorMessage === ''" chooseStyleClass="display-none" i18n-uploadLabel="@@file-upload-modal-resume-upload" uploadLabel="Resume upload">
      <ng-template let-file pTemplate="file"></ng-template>
      <ng-template pTemplate="content">
        @if (badFiles.length === 0) {
          <div class="text-align-center" style="height: 50px">
            @if (uploading) {
              <p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner>
            }
          </div>
        }
        @for (file of badFiles; track file.name) {
          <p-message severity="error" [text]="file.name" class="block my-2"></p-message>
        }
        @for (file of goodFiles; track file.name) {
          <p-message severity="success" [text]="file.name" class="block my-2"></p-message>
        }
      </ng-template>
    </p-fileupload>
  </div>

  <div style="margin: 20px 0px; text-align: right">
    <div class="field-label">
      <p-button icon="fa fa-solid fa-xmark" i18n-label="@@common-close" label="Close" (onClick)="onClose()" severity="secondary" class="ml-1"></p-button>
    </div>
  </div>

</form>
